import { render, staticRenderFns } from "./CreateGiftButton.vue?vue&type=template&id=705806f3&scoped=true&"
import script from "./CreateGiftButton.vue?vue&type=script&lang=js&"
export * from "./CreateGiftButton.vue?vue&type=script&lang=js&"
import style0 from "./CreateGiftButton.vue?vue&type=style&index=0&id=705806f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705806f3",
  null
  
)

export default component.exports